"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postNewPassword = postNewPassword;
const axios_1 = __importDefault(require("axios"));
async function postNewPassword(newPassword, oldPassword) {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken)
        throw new Error('could not get access token');
    await axios_1.default.post('/api/password', {
        newPassword,
        oldPassword,
    }, {
        headers: {
            'x-access-token': accessToken,
        },
    });
}
